'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addToTree = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _ramda = require('ramda');

var addToTree = exports.addToTree = function addToTree(tree, path, value) {
  var currentPosition = tree;
  path.forEach(function (pathSegment, i) {
    var lastSegment = i === path.length - 1;
    currentPosition[pathSegment] = currentPosition[pathSegment] || (lastSegment ? value : {});
    currentPosition = currentPosition[pathSegment];
  });
};

var addArrayToTree = function addArrayToTree(tree, des, array) {
  var _des = _slicedToArray(des, 2),
      path = _des[0],
      memberSchema = _des[1];

  var currentPosition = tree;
  path.forEach(function (pathSegment, i) {
    var lastSegment = i === path.length - 1;
    currentPosition[pathSegment] = currentPosition[pathSegment] || (lastSegment ? array.map(function (member, memberIndex) {
      return Object.keys(memberSchema).reduce(function (obj, key) {
        var memberPath = memberSchema[key];
        if (!member[key].editable) return obj;
        var memberValue = member[key].value;

        return (0, _ramda.assocPath)(memberPath, memberValue, obj);
      }, {});
    }).filter(function (member) {
      return Object.keys(member).length;
    }) : {});
  });
};

var prepareSubmission = function prepareSubmission(jsonPaths, fieldsState) {
  var tree = {};
  Object.keys(fieldsState).forEach(function (fieldKey) {
    var field = fieldsState[fieldKey];
    if (!field) {
      // console.error(`No data for field ${fieldKey}`)
    } else if (field.editable) {
      addToTree(tree, jsonPaths[fieldKey], field.value);
    } else if (Array.isArray(field)) {
      tree = (0, _ramda.assocPath)(jsonPaths[fieldKey][0], fieldsState[fieldKey].map(function (member) {
        return prepareSubmission(jsonPaths[fieldKey][1], member);
      }), tree);
    }
  });
  return tree;
};

exports.default = prepareSubmission;


//////////////////
// WEBPACK FOOTER
// ./node_modules/form-metadata-2/dist/prepareSubmission.js
// module id = 814
// module chunks = 0